module.exports = __webpack_public_path__ + "img/hp-one-3.bdf3748e.jpg";